import { useEffect } from "react"

/** True once the visual viewport is back to full height, i.e. no keyboard covers it. */
export const isKeyboardClosed = (
	visualHeight: number,
	layoutHeight: number,
): boolean => visualHeight >= layoutHeight - 1

/**
 * The app shells fit the viewport and scroll inside their own panes, so the
 * page itself must never scroll: on iOS a scrollable document drags the shell
 * off screen and shows empty background under it.
 */
export function useLockDocumentScroll() {
	useEffect(() => {
		const root = document.documentElement
		root.dataset.appShell = ""

		// iOS pans the page to keep a focused field above the keyboard and can leave
		// it panned once the keyboard closes.
		const viewport = window.visualViewport
		const onViewportResize = () => {
			if (!viewport) return
			if (!isKeyboardClosed(viewport.height, window.innerHeight)) return
			if (window.scrollY !== 0 || window.scrollX !== 0) window.scrollTo(0, 0)
		}
		viewport?.addEventListener("resize", onViewportResize)

		return () => {
			delete root.dataset.appShell
			viewport?.removeEventListener("resize", onViewportResize)
		}
	}, [])
}
